/**
 * X への投稿を、できるだけ X のアプリで開く（Web のページ用）。
 *
 * ブラウザの中で `https://x.com/intent/post` を開くと、アプリでログイン済みでも
 * web のログインを求められてしまう。スマホでは先に `twitter://` を試し、
 * 開かなければ web に落とす。
 *
 * アプリ（Capacitor）の中からは `native-extra.ts` の `openXPost` を使うこと。
 */

/** スマホかどうか。パソコンではそのまま web で開く */
const isPhone = (): boolean => /iPhone|iPad|iPod|Android/.test(navigator.userAgent);

export function openXPostOnWeb(text: string, webUrl: string): boolean {
  if (!isPhone()) return false;
  let left = false;
  const gone = (): void => {
    left = true;
  };
  document.addEventListener('visibilitychange', gone, { once: true });
  addEventListener('pagehide', gone, { once: true });
  // アプリが開かなかったら web へ
  setTimeout(() => {
    if (!left && !document.hidden) location.href = webUrl;
  }, 1500);
  location.href = `twitter://post?message=${encodeURIComponent(text)}`;
  return true;
}
